import React from 'react';
import Modal from '../../layout/Modal'

const FormForum = ({showForm, handleOnChange, handleSubmit, handleClose, isValid}) => {
  return (
    <Modal show={showForm} handleClose={() => handleClose('formForum')}>
      <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header" style={{paddingRight: '30px', paddingLeft: '30px'}}>
            <h5 class="modal-title" id="buat-topik-forumLabel">Buat Topik Forum</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={() => handleClose('formForum')}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style={{padding: '30px',fontSize: '13px'}}>
            <div class="mb-0" action="" id="form-posting-forum">
              <select class="select-primary form-control mb-3" id="" style={{fontSize: '13px'}} name="category" onChange={(e) => handleOnChange(e)}>
                <option hidden="" name="" selected="">Pilih Kategori Forum</option>
                <option name='panduan' value="Panduan Penggunaan">Panduan Penggunaan</option>
                <option name='penyelenggara' value="Perusahaan Penyelenggara">Perusahaan Penyelenggara</option>
                <option name='event' value="Event Kegiatan">Event Kegiatan</option>
                <option name='lain' value="Lain-lainnya">Lain-lainnya</option>
              </select>
              <input class="form-control" name="title" id="pertanyaan" placeholder="Tuliskan Pertanyaan Forum Kesini" style={{padding: '15px',borderRadius: '5px'}} onChange={(e) => handleOnChange(e)}></input>
              <textarea class="form-control" name="content" id="pertanyaan" rows="4" placeholder="Tuliskan Detil Pertanyaan Forum Kesini" style={{marginTop: '10px', padding: '15px',borderRadius: '5px'}} onChange={(e) => handleOnChange(e)}></textarea>
              <button disabled={isValid === false ? true : false} class="btn btn-blue w-100 mb-3" type="submit" style={{marginTop: '15px', padding: '11px 25px !important', fontSize: '13px'}}onClick={() => handleSubmit()}>Posting Forum</button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default FormForum